import React from "react";
import { Badge, TalentechColors } from "@talentech/components";
import { JobStatus } from "@/redux/reducer/directJobs.types";

const STATUS_BADGES: Record<
  JobStatus,
  { color: TalentechColors; label: string }
> = {
  [JobStatus.PUBLISHED]: { color: TalentechColors.SUCCESS, label: "PUBLISHED" },
  [JobStatus.UNPUBLISHED]: {
    color: TalentechColors.INFO,
    label: "UNPUBLISHED",
  },
};

const JobStatusBadge: React.FC<{ status: JobStatus }> = ({ status }) => (
  <Badge {...STATUS_BADGES[status]} />
);

export default JobStatusBadge;
